
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'

var LoanApplyPage = Vue.extend({})
Vue.component('loanApply-page', LoanApplyPage)

export default {
name: 'LoanApplyPage',
directives: {
TransferDom
},
components: {
XTable, XTextarea, XInput, XButton, XDialog,
Selector, Group, XSwitch, InlineXSwitch, Scroller,
Divider, LoadMore, Radio, PopupHeader, Popup, CellBox
},
props: {
saveStatus: Number
},
data () {
return {
baseUrl: this.$store.state.url,
flowId: '4028807450506009015050f267710001',
remark: '',//备注
info: {},
applicant: {},

recCode: '',//单据编号
loanMoney: '',//借款金额
loanMoneyChinese: '',//借款金额大写
willReturnDate: '',//预计还款日期
loanReason: '',//用途
payee: '',//收款人
loanBankName: '',//收款银行
loanBankNo: '',//收款账号
payTypeList: ['转账','现金','其他'],//支付方式
payTypeVal: '',//支付方式-val
payTypeLabel:'',

showToast: false,//所属业务-dialog
businessName: '',//dialog-业务名称
selectorList: [],//dialog-业务类型
selectorValue: '',//dialog-业务类型-val

businessList: [],//dialog-业务搜索结果
businessNameList: [],//dialog-业务搜索结果
businessAllNum: '',//dialog-业务总个数
businessChoosed: {},//dialog-选择的业务
pageNum: 1,//dialog-业务搜索结果-页码
switchValue: false,//dialog-选择业务switch

preStatus: true,
nextStatus: false,

accountUnitList: [],//记账单位
accountUnitValue: '',
accountUnitLabel: '',
accountUniId: '',//记账单位ID

bankAccount: '',//银行信息

fileObj: {},//上传附件集合
fileShowList: [],//上传附件集合-预览
uploadedFileIdList: [],//已上传附件ID集合

selectModelFlag: false, //下拉选择弹框控制
selectModelTitle: '', //下拉选择弹框标题
selectModelData:[], //下拉选择弹框数据
selectModel: ''
}
},
computed: {
loanStatusStr: function () {//单据状态-计算属性
let status = this.info.loanStatus;
let statusStr;
if(status==''){
statusStr = '';
}else if(status==0){
statusStr = '待审批';
}else if(status==1){
statusStr = '待发放';
}else if(status==2){
statusStr = '待归还';
}else if(status==3){
statusStr = '已归还';
}
return statusStr;
}
},
mounted () {
this.getAccountUnit();
this.axios({
url: this.baseUrl+'/wechat/loan/modLoan',
method: 'get'
}).then((response) => {
this.info = response.data.obj;
this.applicant = response.data.obj.applicant;
}).catch((response) => {
this.$vux.loading.hide();
});
this.$emit('sendTitleToParent','借款申请');
},
methods: {
showMsg (msg) {
this.$vux.alert.show({
title: msg
});
setTimeout(() => {
this.$vux.alert.hide();
}, 2000)
},
openSelectModelFlage(type,data){
console.log('openSelectModelFlage',data);

this.selectModelData = [];
if(type == 'payType'){
this.selectModelTitle = '请选择支付方式';
this.selectModel = this.payTypeVal;
this.selectModelData = data;
}else {
this.selectModelTitle = '请选择记账单位';
this.selectModel = this.accountUnitValue;
data.forEach((item) => {
item.key = item.fsn;
item.value = item.name;
this.selectModelData.push(item);
})
}
this.selectModelFlag = true;
},
getLeaveType (value, label) {

this.accountUniId = value;

let isChange = value == this.selectModel ? false : true
if(this.selectModelTitle == '请选择支付方式'){
this.selectModel = this.payTypeVal = value
this.payTypeLabel = label
} else {
this.selectModel = this.accountUnitValue = value
this.accountUnitLabel = label
}
if(isChange){
this.selectModelFlag = false;
if(this.selectModelTitle == '请选择记账单位'){
this.getBankAccount();
}
}
console.log(this.selectModel)
},
async openDialog () {// 打开选择业务-dialog
this.showToast = true;
this.$vux.loading.show({
text: '加载中'
});
let res = await this.axios({
url: this.baseUrl+'/wechat/commonInterface/listRefFlowTypes',
method: 'get'
});
this.selectorList = res.data.list;
this.searchBusiness();
},
async searchBusiness () {// dialog-搜索业务
let res = await this.axios({
url: this.baseUrl+'/wechat/commonInterface/businessList?businessName='+this.businessName+'&flowType='+this.selectorValue+'&page='+this.pageNum+'&rows=15',
method: 'get'
});
this.$vux.loading.hide();
this.businessList = res.data.list;
let businessLength = res.data.list.length;
for(let i=0;i<businessLength;i++){
this.businessNameList.push(res.data.list[i].businessName);
}
this.businessAllNum = Math.ceil(res.data.total/15);
},
transferChinese () {
if(isNaN(this.loanMoney)&&this.loanMoney!=''){
this.showMsg('借款金额请输入数字');
}else{
let chineseStr = this.$common.changeMoneyToChinese(this.loanMoney);
this.loanMoneyChinese = chineseStr;
}
},
chooseDate () {//预计还款日期
let that = this;
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD',
value: this.willReturnDate,
onConfirm (val) {
that.willReturnDate = val;
}
})
},
getPrePage () {//dialog-上一页
if(this.pageNum == 1){
this.preStatus = true;
}else{
this.businessChoosed = {};
this.nextStatus = false;
this.pageNum--;
this.searchBusiness();
}
},
getNextPage () {//dialog-下一页
if(this.pageNum == this.businessAllNum){
this.nextStatus = true;
}else{
this.businessChoosed = {};
this.preStatus = false;
this.pageNum++;
this.searchBusiness();
}
},
chooseBusiness () {//dialog-确定
this.showToast = false;
},
clearBusiness () {// 清除业务
this.businessChoosed = {};
},
async getAccountUnit () {//获取记账单位
let res = await this.axios({
url: this.baseUrl+'/wechat/commonInterface/listAccountUnit',
method: 'get'
});

let list = res.data.list;
this.accountUnitList.push({fsn:'',id:'',name:''});
for(let i=0;i<list.length;i++){
this.accountUnitList.push(list[i]);
}

},
onAccountUnitChange (v) {
this.getBankAccount();
},
async getBankAccount () {//获取银行信息
let res = await this.axios({
url: this.baseUrl+'/wechat/commonInterface/getBankAccount?accountUnitName='+this.accountUnitLabel,
method: 'get'
});
this.bankAccount = res.data.bankAccount;
},
saveForm () {//保存
if(this.loanMoney == ''||this.willReturnDate == ''||this.accountUnitValue == ''){
this.showMsg('请补充必填信息');
return false;
}
this.$vux.loading.show({
text: '加载中'
});
let accountArr = this.accountUnitList;
let formData = new FormData();
for(let i=0;i<accountArr.length;i++){
if(this.accountUnitList[i].fsn == this.accountUnitValue){
formData.append("faccountUnit",this.accountUnitList[i].name);
}
}
formData.append("id",this.info.id);
formData.append("flowId",this.info.flowId);
formData.append("fillDate",this.info.fillDate);
formData.append("recCode",this.recCode);
formData.append("loanStatus",this.info.loanStatus);
formData.append("loanMoney",this.loanMoney);
formData.append("loanMoneyDaxie",this.loanMoneyChinese);
formData.append("willReturnDate",this.willReturnDate);
if(this.businessChoosed.id){
formData.append("businessId",this.businessChoosed.id);
}
if(this.businessChoosed.reportNo){
formData.append("businessReport",this.businessChoosed.reportNo);
}
if(this.businessChoosed.businessName){
formData.append("businessName",this.businessChoosed.businessName);
}
formData.append("loanReason",this.loanReason);
formData.append("payee",this.payee);
formData.append("loanBankName",this.loanBankName);
formData.append("loanBankNo",this.loanBankNo);
formData.append("payType",this.payTypeVal);
formData.append("faccountUnitFsn",this.accountUnitValue);
formData.append("payBankName",this.bankAccount.FAccountName);
formData.append("payBankNo",this.bankAccount.FAccountNo);
formData.append("remark",this.remark);

this.axios({
url: this.baseUrl+'/wechat/loan/saveForm',
method: 'post',
data: formData
}).then((response) => {
console.log('saveForm',response.data,this.saveStatus);
if(response.data.status == 0){//保存失败
console.log('保存失败');
this.$vux.loading.hide();
this.showMsg(response.data.msg);
}else if(this.saveStatus == 0&&response.data.status == 1){//父组件操作发起，并且保存成功
console.log('startFlow');
this.startFlow();
}else if(this.saveStatus == 1&&response.data.status == 1){//父组件操作提交，并且保存成功
console.log('$emit');
this.$emit('sendStatusToParent',{status:1});
this.$vux.loading.hide();
}

}).catch((response) => {
this.$vux.loading.hide();
});
},
startFlow () {//发起
let startData = new FormData();
startData.append("id",this.info.id);
startData.append("flowId",this.info.flowId);
this.axios({
url: this.baseUrl+'/wechat/loan/startFlow',
method: 'post',
data: startData
}).then((response) => {
console.log('startFlow',response.data);
this.showMsg('保存成功！请继续完成提交操作！');

if(response.data.status == 1){

this.$emit('sendStatusToParent',{
status:0,
id:response.data.taskId,
stepId:response.data.stepId
});
}
this.$vux.loading.hide();
}).catch((response) => {
this.$vux.loading.hide();
});

},
chooseFile () {// 选择附件
this.fileObj = document.getElementById('file').files;
this.$vux.loading.show({
text: '保存中'
});
this.submitFile();
},
deleteFile (index) {// 删除已选附件
this.fileShowList.splice(index,1);

let deleteFileId = this.uploadedFileIdList[index];
let fileData = new FormData();
fileData.append("fileId",deleteFileId);
this.$vux.loading.show({
text: '删除中'
});
this.axios({
url: this.baseUrl+'/wechat/commonFile/deleteFile',
method: 'post',
data: fileData
}).then((response) => {
this.$vux.loading.hide();
this.uploadedFileIdList.splice(index,1);
}).catch((response) => {
this.$vux.loading.hide();
});

},
async submitFile () {// 上传附件-图片
let fileObjL = this.fileObj.length;
for(let i=0;i<fileObjL;i++){
let fileData = new FormData();
fileData.append("file",this.fileObj[i]);
fileData.append("taskId",this.info.id);
fileData.append("refRecordId",this.info.id);
fileData.append("refModule","AuditAchieveDoc");
fileData.append("flowId",this.flowId);

let res = await this.axios({
url: this.baseUrl+'/wechat/commonFile/uploadFile',
method: 'post',
data: fileData
});
this.uploadedFileIdList.push(res.data.fileId);

let that = this;
let file = this.fileObj[i];
let reader = new FileReader();
reader.readAsDataURL(file);
reader.onload=function(e) {
that.fileShowList.push(this.result);
}
}

this.$vux.loading.hide();
},
}
}



// WEBPACK FOOTER //
// ./src/components/launch/finance/loanApply.vue